/* unplugin-vue-components disabled */import { render } from "./share-chat.vue?vue&type=template&id=a818db4a&scoped=true"
import script from "./share-chat.vue?vue&type=script&setup=true&lang=js"
export * from "./share-chat.vue?vue&type=script&setup=true&lang=js"

import "./share-chat.vue?vue&type=style&index=0&id=a818db4a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a818db4a"],['__file',"src/pages/share-chat/share-chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a818db4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a818db4a', __exports__)) {
    api.reload('a818db4a', __exports__)
  }
  
  module.hot.accept("./share-chat.vue?vue&type=template&id=a818db4a&scoped=true", () => {
    api.rerender('a818db4a', render)
  })

}


export default __exports__